export enum AppLanguage {
    EN = 'en', NL = 'nl', FI = 'fi', DE = 'de'
}
